import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter';
import { ServiceTypeEnum } from '@supoui/shared/model/enumerations/service-type.enum';

export class ServiceItemType {
  id: number;
  name: string;
  code: string;
  vat: boolean;
  sosServiceType: ServiceTypeEnum;
  uiSortIndex: number;
  activateOn: Date;
  deactivateOn: Date | null;

  public constructor(init?: Partial<ServiceItemType>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ServiceItemTypeAdapter implements Adapter<ServiceItemType> {
  adapt(item: any): ServiceItemType {
    const sosServiceType: ServiceTypeEnum = ServiceTypeEnum[String(item.serviceType)];
    const deactivateOn = item.deactivateOn ? new Date(item.deactivateOn) : null;
    return new ServiceItemType({
      id: item.serviceItemCode,
      name: item.serviceItemName,
      code: item.serviceItemCode,
      vat: item.vat,
      sosServiceType,
      uiSortIndex: item.uiSortIndex,
      activateOn: new Date(item.activateOn),
      deactivateOn
    });
  }
}
